module.exports = __webpack_public_path__ + "img/dead-tree-desert-04.09db39d5.png";